import Vue from 'vue';
import Vuex from 'vuex';

import User from './models/User';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state: {
    user: null
  },
  getters: {
    getUser: (state) => () => {
      return state.user;
    }
  },
  actions: {
    async userLogin(context, params) {
      try {
        let user = await User.login();
        context.commit("setUser", user);
        return Promise.resolve(user);
      }
      catch (error) {
        return Promise.reject(error);
      }
    },
    async userRefresh(context, params) {
      try {
        let user = await User.refresh();
        context.commit("setUser", user);
        return Promise.resolve(user);
      }
      catch (error) {
        return Promise.reject(error);
      }
    },
    async userLogout(context, params) {
      try {
        await User.logout();
        context.commit("setUser", null);
        return Promise.resolve();
      }
      catch (error) {
        return Promise.reject(error);
      }
    },
    async userUpgrade(context, params) {
      try {
        let user = await context.state.user.upgrade(
          params.token, 
          params.amount, 
          params.currency, 
          params.test);
        context.commit("setUser", user);
        return Promise.resolve();
      }
      catch (error) {
        return Promise.reject(error);
      }
    }
  },
  mutations: {
    setUser: (state, user) => {
      state.user = user;
    }
  }
})

export default store;